import { KF_BLINK } from '@/constants/keyframes';
import {
	Box,
	Heading,
	IconButton,
	Popover,
	PopoverBody,
	PopoverCloseButton,
	PopoverContent,
	PopoverHeader,
	PopoverTrigger,
	Text,
} from '@chakra-ui/react';
import { t } from 'i18next';
import { FiBell } from 'react-icons/fi';
import Notification from './components/notification.component';
import TimezoneModal from './components/timezone-modal/timezone.modal';
import { useNotificationsController } from './notifications.controller';

export default function Notifications() {
	const { notifications } = useNotificationsController();
	return (
		<>
			<Popover placement="bottom">
				<PopoverTrigger>
					<IconButton
						aria-label="open menu"
						icon={
							<Box
								animation={notifications.length === 0 ? 'none' : `${KF_BLINK} 1s ease-in-out infinite`}
								position="relative"
								color={notifications.length === 0 ? 'black' : 'primary.700'}
							>
								<FiBell />
								{notifications.length === 0 ? null : (
									<Box bg="red.600" p={1.5} position="absolute" top={-1} right={-0.5} borderRadius="full" />
								)}
							</Box>
						}
					/>
				</PopoverTrigger>
				<PopoverContent w={{ lg: 'xl' }} m={2} mx={4} shadow="md">
					<PopoverHeader py={8} px={6} display="grid" gridTemplateColumns="1fr auto" alignItems="center">
						<Heading size="md">{t('Notifications')}</Heading>
						<PopoverCloseButton size="sm" position="static" />
					</PopoverHeader>
					<PopoverBody bg="black.50" px={4} py={8}>
						<Box display="grid" gap={2}>
							{notifications.map((n) => (
								<Notification key={n.title} {...n} />
							))}
							{notifications.length === 0 ? (
								<Text textAlign="center">{t('There are no unread notifications')}</Text>
							) : null}
						</Box>
					</PopoverBody>
				</PopoverContent>
			</Popover>
			<TimezoneModal />
		</>
	);
}
